import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    ISelectedVariants,
    ISetVariantsImage,
    IVariantGridData,
    IVariantImageModelData,
} from '@app/add-product/models/variant-grid-data-model';
import { SetsService } from '@app/sets/services/sets.service';
import * as _ from 'lodash';

@Component({
    selector: 'sp-copy-images-dialog',
    templateUrl: './copy-images-dialog.component.html',
    styleUrls: ['./copy-images-dialog.component.scss'],
})
export class CopyImagesDialogComponent implements OnInit {
    allVariantImages: Array<string> = [];
    maxSelection: number;
    selectedVariantImages: Array<string> = [];
    currentVariantImages: Array<string>;
    constructor(
        public setsService: SetsService,
        private dialogRef: MatDialogRef<CopyImagesDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public variantImageModalData: IVariantImageModelData
    ) {}

    ngOnInit(): void {
        this.currentVariantImages = this.setsService.selectedVaraintsList[
            this.variantImageModalData.currentVariantIndex
        ].variantImages
            ? this.setsService.selectedVaraintsList[
                  this.variantImageModalData.currentVariantIndex
              ].variantImages.map(
                  (image: ISetVariantsImage) => image.previewUrl
              )
            : []; // Get current variant images

        this.maxSelection = this.currentVariantImages
            ? (this.maxSelection = 6 - this.currentVariantImages.length)
            : 6; // Get max number of images user can choose

        this.allVariantImages = _.cloneDeep(
            []
                .concat(
                    ...this.setsService.selectedVaraintsList
                        .map(
                            (selectedVaraint: ISelectedVariants) =>
                                selectedVaraint.variantImages
                        )
                        .filter(
                            (variantImages: Array<ISetVariantsImage>, index) =>
                                this.variantImageModalData
                                    .currentVariantIndex != index
                        )
                )
                .map(
                    (variantImage: ISetVariantsImage) => variantImage.previewUrl
                )
                .filter(
                    (
                        variantImageId: string,
                        index: number,
                        self: Array<string>
                    ) => self.indexOf(variantImageId) === index
                )
                .filter(
                    (imageId) => !this.currentVariantImages.includes(imageId)
                )
        ); // Get all images from all variants except current variant and exclude images which already copied to current variant
    }

    getImageUrl(id: string): string {
        return this.setsService.getFromMediaStore(id);
    }

    isSelected(imageId: string): boolean {
        return this.selectedVariantImages.some(
            (selectedImageId) => selectedImageId === imageId
        );
    }

    toggleSelection(imageId: string) {
        if (this.isSelected(imageId)) {
            this.selectedVariantImages = this.selectedVariantImages.filter(
                (selectedImageId) => selectedImageId !== imageId
            );
        } else {
            if (this.selectedVariantImages.length < this.maxSelection) {
                this.selectedVariantImages.push(imageId);
            }
        }
    }

    isTileDisabled(imageId: string): boolean {
        return (
            !this.isSelected(imageId) &&
            this.selectedVariantImages.length >= this.maxSelection
        );
    }

    saveImages(): void {
        const variantImages: Array<ISetVariantsImage> = [];
        this.selectedVariantImages.forEach((imageId) => {
            const copyImage: ISetVariantsImage = {
                file: new File([], ''),
                state: '',
                progress: 100,
                previewUrl: imageId,
                isuploaded: true,
            };
            variantImages.push(copyImage);
        });
        this.setsService.selectedVaraintsList[
            this.variantImageModalData.currentVariantIndex
        ].variantImages = this.setsService.selectedVaraintsList[
            this.variantImageModalData.currentVariantIndex
        ].variantImages
            ? [
                  ...this.setsService.selectedVaraintsList[
                      this.variantImageModalData.currentVariantIndex
                  ].variantImages,
                  ...variantImages,
              ]
            : variantImages;
        this.dialogRef.close();
    }

    sumOfQuantity(bundleIndex: number): number {
        return this.setsService.selectedVaraintsList[
            bundleIndex
        ].variants.reduce(
            (acc: number, variantGridData: IVariantGridData) =>
                acc + +variantGridData.quantity,
            0
        );
    }

    close(): void {
        this.dialogRef.close();
    }
}
